import prompthubEllipse from '../images/icons/prompthub-ellipse.svg';
import { PromptCard, PromptDto } from '../components/types';
import { mapCategoriesToRussian } from './categories';

export function transformPromptDtoToCard(dto: PromptDto): PromptCard {
    return {
        ...dto,
        id: dto.id,
        title: dto.title,
        description: dto.description,
        // @ts-expect-error поправим типы когда напишем единый маппер
        categories: dto.categories,
        prompt: dto.prompt,
        prompt_for_example: dto.promptForExample,
        example: dto.example,
        imageData: dto.imageData,
        likes: dto.likes,
        visits: dto.visits,
        video: dto.videoData.url,
        isEditorial: dto?.author?.uid === '0' && dto.id % 2 === 0,
        avatar: dto?.author?.image || prompthubEllipse,
        image: dto.imageData.urlOptimized,
        isLiked: dto.isLiked,
        // Берем первые 3 категории и преобразуем в русские названия
        tags: mapCategoriesToRussian(dto.categoriesEn.slice(0, 3)),
    };
}
